export default [
  {
    path: '/',
    name: 'signature',
    component: () => import('@/components/form/form-signature.vue')
  }
]